const LayoutNavContainer = ({ children }: { children: React.ReactNode }) => {
  return <div className="p-6 flex-auto bg-blue-50">{children}</div>;
};

export default LayoutNavContainer;
